<template>
  <button
    v-if="story.parent_id"
    type="button"
    class="dl-tag"
    :class="{ 'dl-tag--drift': story.in_sync === false }"
    :title="story.in_sync === false ? `Out of sync with doc story #${story.parent_id}` : `Doc story #${story.parent_id}`"
    @click.stop="$emit('open')"
  >
    <i class="fas" :class="story.in_sync === false ? 'fa-exclamation-triangle' : 'fa-file-alt'"></i>
    #{{ story.parent_id }}
  </button>
</template>

<script>
export default {
  props: {
    story: { type: Object, required: true }
  }
}
</script>

<style scoped>
.dl-tag {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 6px;
  border-radius: 3px;
  flex-shrink: 0;
  border: 1px solid transparent;
  background: transparent;
  color: #6B7280;
  font-family: inherit;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1;
}

.dl-tag i {
  font-size: 11px;
}

.dl-tag:hover {
  background: #F3F6FA;
  color: #0B5DB4;
}

.dl-tag--drift {
  background: #FFF7E8;
  border-color: #F5DFB5;
  color: #7A4A00;
}

.dl-tag--drift i {
  color: #D98A00;
}

.dl-tag--drift:hover {
  background: #FFF7E8;
  color: #5E3A00;
}
</style>
